export default class SettingsHelper {
    private static settings = {} as any

    public static init() {
        const settings = (window as any)._settings
        this.settings = this.flattenObject(settings)
    }

    public static getSetting(key: string): any {
        const setting = this.settings[key]
        if (setting !== undefined) {
            return setting
        }
        console.log("ERROR : no setting found for key ", key)
    }

    public static getParkLlocales(): string[] {
        const settings = (window as any)._settings
        return settings.locales || ["fr"]
    }

    private static flattenObject(obj: any) {
        const toReturn: {[key: string]: string} = {}

        for (const key in obj) {
            const element = obj[key]
            if (typeof element === "object") {
                const flatObject = this.flattenObject(element)
                for (const flatKey in flatObject) {
                    toReturn[key + "." + flatKey] = flatObject[flatKey]
                }
            } else {
                toReturn[key] = element
            }
        }

        return toReturn
    }
}
